import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import AdminPageHeader from "@/components/admin/AdminPageHeader";
import { EditorialList, EditorialRow } from "@/components/admin/EditorialList";
import EditorialEmptyState from "@/components/editorial/EditorialEmptyState";
import portraitSilhouetteLottie from "@/assets/lottie/portrait-silhouette.json";
import { EDITORIAL_ASSETS } from "@/lib/editorialAssets";
import { FrameIllustration } from "@/components/admin/EditorialIllustrations";

export default function AdminCustomers() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/customers").then((r) => setCustomers(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-8" data-testid="admin-customers-page">
      <AdminPageHeader
        breadcrumb={["CLIENTS", "CUSTOMERS"]}
        title="Client directory"
        count={customers.length}
      />

      {!loading && customers.length === 0 ? (
        <EditorialEmptyState
          icon={<FrameIllustration />}
          lottie={portraitSilhouetteLottie}
          eyebrow="The directory is open"
          headline={<>No clients on the books <em>yet</em>.</>}
          description="When new bookings come in, your clients will be referenced here — alphabetically, by sittings."
          tone="charcoal"
          backdrop={EDITORIAL_ASSETS.editorial_bw_portrait.src}
          data-testid="customers-empty"
        />
      ) : (
        <EditorialList>
          {loading && (
            <div className="py-10 text-center text-[11px] uppercase tracking-[0.28em] text-muted-foreground">Loading…</div>
          )}
          {customers.map((c, i) => (
            <EditorialRow
              key={c.email}
              index={i}
              title={c.name || c.email}
              meta={[
                c.email,
                c.phone || null,
                `${c.booking_count} ${c.booking_count === 1 ? "sitting" : "sittings"}`,
                c.last_booking_at ? `last ${new Date(c.last_booking_at).toLocaleDateString()}` : null,
              ]}
              data-testid={`customer-row-${i}`}
            />
          ))}
        </EditorialList>
      )}
    </div>
  );
}
